// Helpers do Grupo Econômico (cluster de clientes)

/**
 * Nome do cliente conforme a configuração de exibição (Clientes.nome, resolvido
 * no backend a partir da razão social ou do nome fantasia).
 */
export const getNomeCliente = (option) => option?.nome || "";

/**
 * Label central das options de cliente nos autocompletes.
 * Para grupos econômicos (sem clienteErpId) retorna "GRUPO — nome";
 * para clientes comuns mantém o formato atual "clienteErpId - nome".
 * Obs.: nos autocompletes virtualizados (VirtualizedAutocomplete) a marcação
 * precisa ser via texto — o listBoxComponent renderiza a key da option,
 * não os children de um renderOption customizado.
 */
export const getClienteOptionLabel = (option) => {
  if (!option) return "";

  const nome = getNomeCliente(option);

  if (option?.isGrupoEconomico) {
    return `GRUPO — ${nome}`;
  }

  return `${option?.clienteErpId || ""} - ${nome || "Sem nome"}`;
};
